var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"actions":_vm.actions,"form":_vm.form,"title":_vm.$t('model.profile'),"onFetchData":_vm.onFetchData,"onFormSubmit":_vm.onFormSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }